import { topicTags } from '@/mocks/homeData';

export default function TopicTags() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-white">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">话题广场</h2>
          <p className="section-subtitle">全网最热话题标签，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicTags.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 bg-background-50 hover:bg-primary-50 border border-background-200 hover:border-primary-200 rounded-full px-4 py-2.5 md:px-5 md:py-3 transition-all cursor-pointer"
            >
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs font-medium text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}